<div class="max-w-4xl mx-auto p-6">
  <h1 class="text-2xl font-bold text-gray-800 mb-1">Borrado de proyecto</h1>
  <p *ngIf="batch" class="text-gray-600 mb-4">
    Proyecto: <b>{{ batch.projectName }}</b>
    <span class="ml-2 inline-block px-2 py-0.5 rounded text-sm border">{{ statusLabel(batch.status) }}</span>
  </p>

  <div *ngIf="loading && !batch" class="py-8 text-center text-gray-500">Cargando…</div>

  <div *ngIf="batch">
    <div class="w-full bg-gray-200 rounded-full h-4 mb-2 overflow-hidden">
      <div class="bg-red-600 h-4 transition-all duration-300" [style.width.%]="progress"></div>
    </div>
    <p class="text-sm text-gray-600 mb-4">
      {{ progress }}% — {{ batch.successCount }} ok / {{ batch.failedCount }} fallidos / {{ batch.skippedCount }} omitidos de {{ batch.totalSteps }}
    </p>

    <div *ngIf="batch.blockReason" class="bg-red-50 border border-red-300 rounded p-3 mb-4 text-sm text-red-700">
      <b>Bloqueado:</b> {{ batch.blockReason }}
    </div>

    <div class="mb-4">
      <button *ngIf="isRunning" class="px-4 py-2 rounded bg-red-600 text-white disabled:opacity-40" [disabled]="cancelling" (click)="cancel()">
        {{ cancelling ? 'Cancelando…' : 'Cancelar borrado' }}
      </button>
    </div>

    <table class="w-full text-sm">
      <thead>
        <tr class="text-left border-b">
          <th class="py-1">Tipo</th>
          <th>Planificado</th>
          <th>Afectados</th>
          <th>Estado</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let it of batch.items; trackBy: trackById" class="border-b">
          <td class="py-1">{{ it.entityType }}</td>
          <td>{{ it.plannedCount }}</td>
          <td>{{ it.affectedRows }}</td>
          <td>{{ statusLabel(it.status) }}</td>
          <td>
            <span *ngIf="it.error" class="text-red-600 cursor-help" [title]="it.error">⚠</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
